module.exports = __webpack_public_path__ + "static/index/img/baikal-700.4854979e.jpg";